import Link from 'next/link';

interface ClosingCTAProps {
  className?: string;
}

const ClosingCTA = ({ className = '' }: ClosingCTAProps) => {
  return (
    <section className={`bg-surface py-16 lg:py-24 ${className}`}>
      <div className="mx-auto max-w-5xl px-6 text-center lg:px-8">
        <div className="mx-auto mb-10 flex items-center justify-center gap-4 text-accent">
          <span className="h-px w-12 bg-accent"></span>
          <span>✦</span>
          <span className="h-px w-12 bg-accent"></span>
        </div>

        <h2 className="font-heading text-[44px] font-normal leading-[1] text-foreground md:text-[64px]">
          Not sure which path fits your <span className="italic text-plum">situation?</span>
        </h2>

        <p className="mx-auto mt-7 max-w-3xl font-heading text-[22px] leading-[1.55] text-muted-foreground">
          That&apos;s exactly the conversation we&apos;re built for. Tell us about your property and
          your circumstances — no obligation, no pressure. We&apos;ll give you a straight answer about
          what makes sense.
        </p>

        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
          <Link
            href="/for-sellers#property-form"
            className="inline-flex items-center justify-center bg-plum px-6 py-4 text-[12px] font-bold uppercase tracking-[0.24em] text-primary-foreground transition-colors hover:bg-plum-deep"
          >
            Tell Us About Your Property →
          </Link>
          <Link
            href="/for-sellers#process-timeline"
            className="inline-flex items-center justify-center border border-border bg-card px-6 py-4 text-[12px] font-bold uppercase tracking-[0.2em] text-foreground transition-colors hover:border-plum hover:bg-background"
          >
            See How It Works →
          </Link>
        </div>

        <p className="mt-8 text-[12px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">
          No fees. No obligation. No one-size-fits-all answers.
        </p>
      </div>
    </section>
  );
};

export default ClosingCTA;
